import { createLogger } from "@/lib/logger";

const log = createLogger("prewarmTranscribe");

// Supabase Edge functions cold-start (~5–10s) when no container is warm.
// A lightweight GET exercises the Deno runtime and module imports so the
// next real transcription skips that delay. The function short-circuits
// on GET and returns 204 — no auth, no rate limit, no provider calls.
let warmed = false;

export function prewarmTranscribe(): void {
  if (warmed) return;
  warmed = true;

  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  if (!supabaseUrl) return;

  const url = `${supabaseUrl}/functions/v1/transcribe-audio`;

  fetch(url, { method: "GET" })
    .then((res) => {
      log.log(`warmup ${res.status}`);
    })
    .catch((err) => {
      // Warmup failure is harmless — the next real call pays the
      // cold-start cost once.
      log.log("warmup failed (non-fatal):", err?.message ?? err);
    });
}

// Exposed for tests only.
export function _resetPrewarmForTests(): void {
  warmed = false;
}
